// Central date formatting — everything in the UI shows DD/MM/YYYY (or DD/MM/YYYY HH:mm).
// Pass an ISO-8601 string (or Date). Empty / invalid → "—".

const pad = (n) => String(n).padStart(2, "0");

const _toDate = (v) => {
  if (v == null || v === "") return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** DD/MM/YYYY */
export const fmtDate = (v) => {
  const d = _toDate(v);
  if (!d) return "—";
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

/** DD/MM/YYYY HH:mm (24h) */
export const fmtDateTime = (v) => {
  const d = _toDate(v);
  if (!d) return "—";
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** DD/MM — compact form for chart axis labels and tight column tags */
export const fmtDateShort = (v) => {
  const d = _toDate(v);
  if (!d) return "—";
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
};

/** Current wall clock in DD/MM/YYYY HH:mm — for "printed at" stamps */
export const nowStamp = () => fmtDateTime(new Date());
